/**
 * @description 上报数据
 * - 配合 https://internal-fed.huya.info/h5/datacenter-tools/index.html 使用，口味更佳
 */
import yaReport from "@/utils/ya-report";
import { once, getDeviceInfo, GETCOOKIE, objToUrlParams, isHUYAApp } from ".";

type ReportParamsType = {
  /** 事件id */
  eid: string;
  eid_desc?: string;
  /** 当前页面 */
  curpage?: string;
  /** 当前位置 */
  curlocation?: string;
  /** JSON.stringify 字符串 */
  prop?: string;
  [key: string]: any;
};

export const deviceInfoPromise = getDeviceInfo();

/**
 * @example 
 * ```ts
 report({
    eid: "usr/click/get_material_taskcard/point_luckydraw_page",
    eid_desc: "积分抽奖活动页活动抽奖货币获取任务卡片按钮点击",
    prop: JSON.stringify({
      task_id,
      status,
      // 0,积分抽奖主页（默认）
      // 1,任务弹窗
      scene,
      ...(await getAppMid()),
    }),
  });
 * ```
 */
export const getAppMid = async () => {
  const deviceInfo = await deviceInfoPromise;
  return {
    app_mid: deviceInfo.androidid || deviceInfo.openUDID || "",
  };
};

/**
 * @example reportInit({ rso: GETCOOKIE("rso") || "" });
 */
export const reportInit = once(async (setExtParamObj?: Record<any, any>) => {
  (window as any).yaReportArr = [];
  const appMidInfo = isHUYAApp ? await getAppMid() : {};
  const baseParams = {
    ...appMidInfo,
    rso: GETCOOKIE("rso") || "",
    ...(setExtParamObj || {}),
  };

  yaReport(
    {
      /** 产品给的。根据自己的业务场景使用，一般是 `huya_hd`，`huyawap` */
      pro: "huya_web",
    },
    objToUrlParams(baseParams, ""),
  );
});

/**
 * @description 数据上报。在全局注入yaReportArr变量
 */
export const report = (arg: ReportParamsType) => {
  reportInit();
  (window as any).yaReportArr.push(arg);
};
